import { Button, Card, Col, Image, Row, Typography } from "antd";
import React from "react";
import RecruiterRole from "assets/recruiter-role.svg";
import EnumeratorRole from "assets/enumerator-role.svg";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import CheckMarkSvg from "assets/check.svg";
import { useNavigate } from "react-router-dom";
import RoleSvg from "assets/role.svg";
import classNames from "classnames";
import { RoleTypes } from "enum/role-type-enum";

const { Title, Text } = Typography;

const PickRole = () => {
  const [role, setRole] = React.useState<any>(null);
  const navigate = useNavigate();

  return (
    <>
      <div className="min-h-screen bg-background px-5 md:px-5 overflow-hidden">
        <div className="max-w-6xl mx-auto my-16">
          <Card className="px-8 py-2 mt-4">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <Title level={2} style={{ fontWeight: 700 }}>
                Choose your role
              </Title>
              <img alt="#" src={RoleSvg} />
            </div>
          </Card>

          <Card className="px-0 md:px-8 py-2 mt-8">
            <Row gutter={[24, 24]}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Card
                  className={classNames(
                    "bg-background",
                    "hover:outline-none",
                    "hover:ring-1",
                    " hover:ring-primary",
                    " hover:border-transparent",
                    " hover:bg-secondary",
                    "cursor-pointer",
                    "position-relative",
                    { "bg-secondary": role && role === RoleTypes.RECRUITER },
                    { "outline-none": role && role === RoleTypes.RECRUITER },
                    { "ring-1": role && role === RoleTypes.RECRUITER },
                    { "ring-primary": role && role === RoleTypes.RECRUITER },
                    { "border-transparent": role && role === RoleTypes.RECRUITER }
                  )}
                  onClick={() => setRole(RoleTypes.RECRUITER)}
                >
                  <Row gutter={[32, 24]}>
                    <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                      <Image src={RecruiterRole} width={42} preview={false} />
                    </Col>
                    <Col xs={24} sm={24} md={21} lg={21} xl={21}>
                      <Title level={3}>I am a recruiter</Title>
                      <Text style={{ fontSize: "16px", color: "#6B7280", lineHeight: "24px" }}>
                        Passionate about finding the perfect match between exceptional talent and
                        career-defining opportunities.
                      </Text>
                    </Col>
                  </Row>
                  {role && role === RoleTypes.RECRUITER && (
                    <div
                      style={{
                        position: "absolute",
                        height: "30px",
                        width: "30px",
                        backgroundColor: "#22AD5C",
                        top: "-5%",
                        left: "-2%",
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img alt="#" src={CheckMarkSvg} />
                    </div>
                  )}
                </Card>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Card
                  className={classNames(
                    "bg-background",
                    "hover:outline-none",
                    "hover:ring-1",
                    " hover:ring-primary",
                    " hover:border-transparent",
                    " hover:bg-secondary",
                    "cursor-pointer",
                    "position-relative",
                    { "bg-secondary": role && role === RoleTypes.ENUMERATOR },
                    { "outline-none": role && role === RoleTypes.ENUMERATOR },
                    { "ring-1": role && role === RoleTypes.ENUMERATOR },
                    { "ring-primary": role && role === RoleTypes.ENUMERATOR },
                    { "border-transparent": role && role === RoleTypes.ENUMERATOR }
                  )}
                  onClick={() => setRole(RoleTypes.ENUMERATOR)}
                >
                  <Row gutter={[32, 24]}>
                    <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                      <Image src={EnumeratorRole} width={42} preview={false} />
                    </Col>
                    <Col xs={24} sm={24} md={21} lg={21} xl={21}>
                      <Title level={3}>I am an enumerator</Title>
                      <Text style={{ fontSize: "16px", color: "#6B7280", lineHeight: "24px" }}>
                        Strategically sculpting my career trajectory for the success – where
                        ambition meets the accomplishment.
                      </Text>
                    </Col>
                  </Row>
                  {role && role === RoleTypes.ENUMERATOR && (
                    <div
                      style={{
                        position: "absolute",
                        height: "30px",
                        width: "30px",
                        backgroundColor: "#22AD5C",
                        top: "-5%",
                        left: "-2%",
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img alt="#" src={CheckMarkSvg} />
                    </div>
                  )}
                </Card>
              </Col>
            </Row>

            <div className="flex flex-col md:flex-row gap-y-2 justify-between  pt-12">
              <Button
                className="h-12 px-8 border border-2 border-border text-base font-bold flex items-center justify-center gap-2"
                onClick={() => navigate("/")}
              >
                <ArrowLeftOutlined />
                Back Home
              </Button>
              <Button
                className="h-12 px-8 border border-2 border-border text-base font-bold flex items-center gap-2 bg-primary justify-center text-white border-none"
                onClick={() => {
                  if (!role) return;
                  navigate(`/login?roleType=${role}`);
                }}
                type="primary"
              >
                Continue
                <ArrowRightOutlined />
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};

export default PickRole;
